import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

export default function Register() {
  const [form, setForm] = useState({ name: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handle = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await axios.post('/api/auth/register', form);
      login(data.token, data.user);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Eroare la înregistrare');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-box">
        <div className="auth-logo">Anxio.co</div>
        <div className="auth-tagline">Primul pas spre liniște. Creează-ți contul.</div>
        <form onSubmit={submit}>
          <div className="form-group">
            <label className="input-label">NUME</label>
            <input className="input" name="name" value={form.name} onChange={handle} placeholder="Prenumele tău" required />
          </div>
          <div className="form-group">
            <label className="input-label">EMAIL</label>
            <input className="input" name="email" type="email" value={form.email} onChange={handle} placeholder="tu@exemplu.ro" required />
          </div>
          <div className="form-group">
            <label className="input-label">PAROLĂ (minim 6 caractere)</label>
            <input className="input" name="password" type="password" value={form.password} onChange={handle} placeholder="••••••" required />
          </div>
          {error && <div className="error-msg" style={{ marginBottom: 12 }}>{error}</div>}
          <button className="btn btn-primary btn-full" disabled={loading}>
            {loading ? 'Se creează contul...' : 'Creează cont'}
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: 16, fontSize: 13, color: 'var(--muted)' }}>
          Ai deja cont?{' '}
          <Link to="/login" style={{ color: 'var(--teal)', fontWeight: 600 }}>Intră în cont</Link>
        </p>
      </div>
    </div>
  );
}
